import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    /**
     * Child Elemente.
     */
    children: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Gibt an ob es einen oberen Rahmen gibt.
     */
    hasTopBorder?: boolean,

    /**
     * Gibt an ob es einen unteren Rahmen gibt.
     */
    hasBottomBorder?: boolean
}

export class ToolBar extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        hasTopBorder: true,
        hasBottomBorder: true
    };

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { children, style, hasTopBorder, hasBottomBorder } = this.props;
        const classNames: string[] = ["toolbar"]

        if (!hasTopBorder)
            classNames.push("toolbar--no-top-border");

        if (!hasBottomBorder)
            classNames.push("toolbar--no-bottom-border");

        return (
            <div
                className={classNames.join(" ")}
                style={style} >
                {children}
            </div>
        );
    }
}